import { render, staticRenderFns } from "./UserAddedItem.vue?vue&type=template&id=5b3de39a&scoped=true&"
import script from "./UserAddedItem.vue?vue&type=script&lang=js&"
export * from "./UserAddedItem.vue?vue&type=script&lang=js&"
import style0 from "./UserAddedItem.vue?vue&type=style&index=0&id=5b3de39a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3de39a",
  null
  
)

export default component.exports